import { FC } from 'react'
import { Navigate } from 'react-router-dom'

import { useIsDietitian } from '@/features/auth'

// 薬剤師側の入口
import IndexPage from '@/pages'
import { LandingOrRedirect } from '@/pages/landing'
import GroupRecordingPage from '@/apps/latest/pages/recording-group'
import NewRecordingPage from '@/apps/latest/pages/recording-new'

// 管理栄養士側の入口
import NutritionKartePage from '@/apps/latest/pages/nutrition/customer'
import NutritionHomePage from '@/apps/latest/pages/nutrition/home'
import NutritionNewCustomerPage from '@/apps/latest/pages/nutrition/new'

// 系統 (薬剤師 / 管理栄養士) の振り分け。legacy / latest の振り分け (portal-dispatchers) と
// 同じ置き方で、 App.tsx のルート表から使う。 **薬剤師のページの中に分岐を書かない**
// (yakureki-back log/224 work-log/01 §2 F1)。
//
// custom_setting を取れるまでは何も描かない。 先に薬剤師のページを描くと、 一覧の取得など
// 薬剤師の API が走ってから飛ぶことになる。 取得に失敗したら薬剤師扱い (= 従来どおり)。
//
// portal (設定) と knowledge は振り分けない。 管理栄養士の左ペインに導線を出さないだけで、
// URL を直接打てば開けることは受け入れる。

// factory: 薬剤師 / 管理栄養士 を is_dietitian で振り分ける
const make = (Pharmacist: FC, Dietitian: FC): FC => {
  const Dispatcher: FC = () => {
    const { isDietitian, isResolved } = useIsDietitian()
    if (!isResolved) return null
    return isDietitian ? <Dietitian /> : <Pharmacist />
  }
  return Dispatcher
}

const ToNutritionHome: FC = () => <Navigate to="/nutrition" replace />
const ToPharmacistHome: FC = () => <Navigate to="/" replace />

// 薬剤師の入口 4 つ: 管理栄養士が来たら /nutrition へ送る (記録の URL は持たない。カルテはお客様の URL 1 つ。ADR-0086)
export const HomeDispatcher = make(LandingOrRedirect, ToNutritionHome)
export const SoapDispatcher = make(IndexPage, ToNutritionHome)
export const NewRecordingDispatcher = make(NewRecordingPage, ToNutritionHome)
export const GroupRecordingDispatcher = make(
  GroupRecordingPage,
  ToNutritionHome
)

// 管理栄養士の入口 3 つ: 薬剤師が来たら / へ戻す
export const NutritionHomeDispatcher = make(ToPharmacistHome, NutritionHomePage)
export const NutritionNewDispatcher = make(
  ToPharmacistHome,
  NutritionNewCustomerPage
)
export const NutritionKarteDispatcher = make(
  ToPharmacistHome,
  NutritionKartePage
)
